
/**
 * @name appMessageBase
 * @description
 * This is config file, it include only global application related messages
 * Define Settings the object way(based on requirement):
 * @example {paramsName}:{value}
 * @constant appMessageBase
 * @type {CommonBase}
 */

export const genericAppMessages = Object.freeze({
  httpError: 'An error occurred while fetching the response. Please try again.',
});

export const subscriptionRenewalMessages = Object.freeze({
  processing: 'Processing your renewal. Please do not close or refresh this page.',
  success: 'Subscription renewed successfully.',
  failure: 'We could not renew your subscription. You have not been charged and your subscription has not changed.',
  unknown: 'We could not confirm your renewal. Please check your profile before trying again.',
});

export const updateCardMessages = Object.freeze({
  title: 'Update Card',
  intro: 'Enter the new card. It will be used for your next payment. You will not be charged now.',
  saving: 'Saving…',
  success: 'Your card was updated.',
  failure: 'We could not update your card. Your current card has not changed.'
});

export const autoRenewMessages = Object.freeze({
  scheduledTitle: 'Auto-Renewal Scheduled',
  confirmTitle: 'Confirm',
  confirmEnable: 'Do you really want to turn on Auto-Renewal?',
  /** Heading of the turn-on pop-up when the renewal date is known (the pop-up hides the plain "Confirm" heading). */
  confirmEnableTitle: 'Turn on Auto-Renewal?',
  /** The one sentence of the turn-on pop-up; `last4` is null when the saved card cannot be read. */
  confirmEnableSentence: (date: string, last4: string | null) =>
    last4
      ? `Subscription will be auto-renewed from the saved card on file ending in ${last4} on ${date}.`
      : `Subscription will be auto-renewed on ${date}.`,
  /** Heading of the turn-off pop-up, so both pop-ups carry a heading. */
  confirmDisableTitle: 'Turn off Auto-Renewal?',
  confirmDisable: 'Do you really want to turn off Auto-Renewal?',
  stateOn: 'Your plan will renew automatically.',
  stateOff: 'Your plan will not renew automatically.',
  enabled: 'Auto-Renewal turned on. Your plan will renew automatically.',
  disabled: 'Auto-Renewal turned off.',
  failure: 'We could not update Auto-Renewal. Please try again.',
  reasons: Object.freeze({
    noCard: 'Auto-Renewal needs a saved card. Renew with a new card first.',
    expired: 'Your subscription has expired. Renew it first to turn on Auto-Renewal.',
    noSubscription: 'There is no subscription to renew automatically.',
    unknown: 'Auto-Renewal is not available for this account right now.'
  })
});

export const subscriptionBannerMessages = Object.freeze({
  expired: 'Please renew your subscription to access platform features.',
  /** `when` is "expires in N days" or "is about to expire". */
  expiringSoon: (when: string) =>
    `Your subscription ${when}. Please renew your subscription now to maintain access to all platform data and features.`
});

export const supportHelpMessages = Object.freeze({
  prompt: 'Need Help?',
  link: 'Contact Support'
});

export const subscriptionDetailsMessages = Object.freeze({
  notFound: 'Subscription details were not found for this company.',
  loadFailed: 'We could not load the subscription details. Please try again.',
  retry: 'Retry',
  backToList: 'Back to User Subscription',
  loading: 'Loading subscription details'
});
